import { Skeleton } from '@common/components';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { SearchPrepareSection } from '@/app/donation/gifts/search/_components/SearchPrepareSection';

interface DropdownContentProps {
  onKeywordClick: (keyword: string) => void;
}

export const DropdownContent = ({ onKeywordClick }: DropdownContentProps) => {
  return (
    <div className="absolute inset-x-0 top-full z-10 mt-12 min-h-260 rounded-small border-1 border-Gray-300 bg-Gray-white p-0 shadow-xl">
      <ErrorBoundary fallback={null}>
        <Suspense
          fallback={
            <div className="flex flex-col gap-16 px-20 py-16">
              <Skeleton className="h-23 w-80" />
              <div className="flex flex-row gap-8">
                <Skeleton className="h-23 w-80" />
                <Skeleton className="h-23 w-80" />
                <Skeleton className="h-23 w-80" />
                <Skeleton className="h-23 w-80" />
              </div>
            </div>
          }
        >
          <SearchPrepareSection
            onHistoryClick={onKeywordClick}
            onRecommendClick={onKeywordClick}
          />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};
